import React from 'react';
import styled from 'styled-components';
import {Formik} from 'formik';
import _ from 'lodash';
import {useTranslation} from 'react-i18next';
import {NotificationManager} from 'react-notifications';
import {Btn, CancelBtn} from '../../../shared/elements/btn/Btn';
import {FormTextarea} from '../../../shared/form/form-control/FormTextarea';
import {createCustomNote} from './endpoints';

export const AddCustomNote = ({onNoteCreate}) => {
    const {t} = useTranslation();
    const [isFormVisible, setIsFormVisible] = React.useState(false);

    const formValues = {note: ''};

    const showForm = () => setIsFormVisible(true);
    const hideForm = () => setIsFormVisible(false);

    const submitForm = (values) => {
        createCustomNote(values.note)
            .then(() => {
                hideForm();
                _.attempt(onNoteCreate);
            })
            .catch(() => {
                NotificationManager.error(t('warehousing.timeline.error'));
            });
    };

    return (
        <div>
            {!isFormVisible && (
                <Btn color="primary" style={{marginTop: 'var(--space-md)'}} onClick={showForm}>
                    {t('warehousing.timeline.customNote.addNote')}
                </Btn>
            )}
            {isFormVisible && (
                <Formik initialValues={formValues} onSubmit={submitForm}>
                    {(form) => (
                        <FormContainer>
                            <FormTextarea
                                rows="3"
                                name="note"
                                type="text"
                                placeholder={t('warehousing.timeline.customNote.placeholder')}
                            />
                            <Btn color="success" onClick={form.submitForm}>
                                {t('general.Save')}
                            </Btn>
                            <CancelBtn color="default" onClick={hideForm}>
                                {t('general.Cancel')}
                            </CancelBtn>
                        </FormContainer>
                    )}
                </Formik>
            )}
        </div>
    );
};

const FormContainer = styled.div`
    margin-top: var(--space-md);
`;
